import script from "./HotelsTravelersPopupComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HotelsTravelersPopupComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HotelsTravelersPopupComponent.vue?vue&type=style&index=0&id=07ae3c45&lang=css"

const __exports__ = script;

export default __exports__